import { Badge, List, ListRow, Section, Text } from '@ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useBlooming } from '../api';
import { period } from '../format';
import styles from './forage.module.css';

/** What blooms now or within two weeks at the locations (LOC-004). */
export function BloomingCard({ hideWhenEmpty = false }: { hideWhenEmpty?: boolean }) {
  const { t } = useTranslation();
  const blooming = useBlooming();
  const rows = blooming.data ?? [];
  if (!blooming.data || (hideWhenEmpty && rows.length === 0)) return null;
  return (
    <Section
      title={t('forage.blooming.title')}
      action={<Link to="/standorte">{t('forage.blooming.all')}</Link>}
    >
      {rows.length === 0 ? (
        <Text tone="muted" className={styles.bloomingEmpty}>
          {t('forage.blooming.empty')}
        </Text>
      ) : (
        <List>
          {rows.slice(0, 6).map((b) => (
            <ListRow
              key={`${b.location.id}-${b.plant.id}`}
              title={b.plant.name}
              description={`${b.location.name} · ${period(b.start, b.end)}`}
              trailing={
                b.status === 'blooming' ? (
                  <Badge tone="success">{t('forage.status.blooming')}</Badge>
                ) : (
                  <Text as="span" size="sm" tone="muted">
                    {t('forage.status.soon')}
                  </Text>
                )
              }
            />
          ))}
        </List>
      )}
    </Section>
  );
}
